"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WifiOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_WifiOff_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.854.854a.5.5 0 0 0-.708-.708l-15 15a.5.5 0 0 0 .708.708l5.713-5.714a3.746 3.746 0 0 1 4.08.81.5.5 0 0 0 .707-.706 4.746 4.746 0 0 0-3.506-1.385l1.946-1.946a6.926 6.926 0 0 1 3.102 1.79.5.5 0 0 0 .708-.706 7.926 7.926 0 0 0-3.01-1.883l1.671-1.672a10.103 10.103 0 0 1 2.881 2.013.5.5 0 0 0 .708-.706c-.84-.839-1.8-1.53-2.841-2.055l2.84-2.84ZM8 2.5c1.014 0 2.014.139 2.974.405l-.825.825A10.116 10.116 0 0 0 .854 6.455a.5.5 0 0 1-.708-.706A11.113 11.113 0 0 1 8 2.5ZM8 5.678l.198.003L7.15 6.729a6.928 6.928 0 0 0-4.045 1.974.5.5 0 0 1-.708-.706A7.93 7.93 0 0 1 8 5.678Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.004c-.423 0-.828.168-1.126.466a.53.53 0 0 0 0 .749l.54.539a.829.829 0 0 0 1.17 0l.54-.54a.53.53 0 0 0 0-.748A1.592 1.592 0 0 0 8 12.004Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_WifiOff_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = WifiOff;
exports["default"] = _default;